import {getRequest, postRequest} from '../api/actions';
import {getCategorySchemeUrl, getCreateDCSCategoryUrl, getImportDCSUrl} from '../../constants/urls';

export const DEFAULT_CATEGORY_SCHEME_SELECTOR_SHOW = 'DEFAULT_CATEGORY_SCHEME_SELECTOR_SHOW';
export const DEFAULT_CATEGORY_SCHEME_SELECTOR_HIDE = 'DEFAULT_CATEGORY_SCHEME_SELECTOR_HIDE';
export const DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_MODAL_SHOW = 'DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_MODAL_SHOW';
export const DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_MODAL_SHOW = 'DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_MODAL_SHOW';
export const DEFAULT_CATEGORY_SCHEME_SELECTOR_CATEGORY_SCHEMES_READ = 'DEFAULT_CATEGORY_SCHEME_SELECTOR_CATEGORY_SCHEMES_READ';
export const DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT = 'DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT';
export const DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT = 'DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT';
export const DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_CHANGE = 'DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_CHANGE';

export const showDefaultCategorySchemeSelector = () => ({
  type: DEFAULT_CATEGORY_SCHEME_SELECTOR_SHOW
});

export const hideDefaultCategorySchemeSelector = () => ({
  type: DEFAULT_CATEGORY_SCHEME_SELECTOR_HIDE
});

export const showDefaultCategorySchemeSelectorSelectModal = () => ({
  type: DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_MODAL_SHOW
});

export const showDefaultCategorySchemeSelectorCreateModal = () => ({
  type: DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_MODAL_SHOW
});

export const readDefaultCategorySchemeSelectorCategorySchemes = () =>
  getRequest(
    DEFAULT_CATEGORY_SCHEME_SELECTOR_CATEGORY_SCHEMES_READ,
    getCategorySchemeUrl()
  );

export const submitDefaultCategorySchemeSelectorSelect = categorySchemeTriplet =>
  getRequest(
    DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT,
    getImportDCSUrl(
      categorySchemeTriplet.id,
      categorySchemeTriplet.agencyID,
      categorySchemeTriplet.version
    ),
    t => ({
      success: t('middlewares.defaultCategorySchemeSelector.messages.selectSubmit.success')
    })
  );

export const submitDefaultCategorySchemeSelectorCreate = cat => postRequest(
  DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT,
  getCreateDCSCategoryUrl(),
  {
    catCode: cat.catCode,
    parCode: null,
    ord: "1",
    labels: cat.labels
  },
  t => ({
    success: t('middlewares.defaultCategorySchemeSelector.messages.createSubmit.success')
  })
);

export const changeDefaultCategorySchemeSelectorCreate = fields => ({
  type: DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_CHANGE,
  fields
});